import { useState, useEffect, useRef, useCallback } from 'react';
import { useCopyToClipboard } from 'react-use';

export function useCopyText(timeout = 2000) {
    const [, copyToClipboard] = useCopyToClipboard();
    const [isCopied, setCopied] = useState(false);
    const timerRef = useRef();

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    const copyText = useCallback(
        (text) => {
            copyToClipboard(text);
            setCopied(true);
            timerRef.current = setTimeout(() => setCopied(false), timeout);
        },
        [timeout]
    );

    return { isCopied, copyText };
}
